import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAddNewTaskMutation } from "./tasksApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave } from "@fortawesome/free-solid-svg-icons"
import TimeLeft from '../../partial/TimeLeft'
import Uploader from "../../partial/Uploader"
import ReactQuill from 'react-quill';
import GradeStepsMain from "../grade-steps/GradeStepsMain"

const NewTaskForm = ({ groups, task }) => {
    const {groupId, type} = useParams()
    const [addNewTask, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewTaskMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState(task?.title||'')
    const [body, setBody] = useState(task?.body||'')
    const [group, setGroup] = useState(groupId!='0'?groupId:'')
    const [active, setActive] = useState(true)
    const [incluedInGrade, setIncluedInGrade] = useState(task?.incluedInGrade || true)
    const [defaultCheckInclueRelatedFriends, setDefaultCheckInclueRelatedFriends] = useState(task?.defaultCheckInclueRelatedFriends || true)

    const [order, setOrder] = useState(task?.order||0)

    const [ratio, setRatio] = useState(task?.ratio||0)
    const [fromDate, setFromDate] = useState(new Date())
    const [toDate, setToDate] = useState(new Date(new Date().setDate(new Date().getDate() + 7)))
    const [img, setImg] = useState(task?.img||'')
    const [gradeSteps, setGradeSteps] = useState(task?.gradeSteps || [])
    useEffect(() => {
        if (isSuccess) {
            setTitle('')
            setBody('')
            setGroup(groupId!='0'?groupId:'')
            setOrder(0)
            setRatio(0)
            setActive(true)
        }
    }, [isSuccess, groupId, navigate])

   
    const canSave = [title, body, group, fromDate, toDate].every(Boolean) && !isLoading

    const onSaveTaskClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            const savedGradesSteps = gradeSteps.map(step => {
                return {
                    ...step,
                    _id: step._id.length > 15? step._id : undefined
                }
            })  

         const {data} =    await addNewTask({ group, title, body, active, fromDate, toDate , order, img, ratio, incluedInGrade, defaultCheckInclueRelatedFriends, gradeSteps : savedGradesSteps })
         if(data?.id)
            navigate(`/${type}/${groupId}/tasks/${data?.id}`)
        }
    }

    const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })

    const errClass = isError ? "errmsg" : "offscreen"

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveTaskClicked}>
                <div className="form__title-row">
                    <h2>New Task</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/tasks`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="title">
                    Title:</label>
                <input
                    className={`form__input  ${!title &&'form__input--incomplete'}`}
                    id="title"
                    maxLength={20}
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                />
               

                <label className="form__label" htmlFor="body">
                    Body:</label>

                    <ReactQuill                   
                    value={body}
                    onChange={setBody}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          //[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{size: []}],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />    
                {/* <textarea
                    className={`form__input form__input--text ${!body &&'form__input--incomplete'}`}
                    id="body"
                    name="body"
                    value={body}
                    onChange={(e)=>setBody(e.target.value)}
                /> */}
                 <Uploader label={'Img'} folderId={'MANAGE_TASKS'} file={img} setFile={setImg} isImg={true} />

                
                <div className="form-flex">

<div className="form-input-container">
                 <label className="form__label" htmlFor="fromDate">
                    From Date:</label>
                <input
                    className={`form__input  ${!fromDate &&'form__input--incomplete'}`}
                    id="fromDate"
                    name="fromDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${fromDate.getFullYear().toString()}-${(fromDate.getMonth() + 1).toString().padStart(2, 0)}-${fromDate.getDate().toString().padStart(2, 0)}T${fromDate.getHours().toString().padStart(2, 0)}:${fromDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setFromDate(new Date(e.target.value))}
                />
                </div>
                <div className="form-input-container">

                <label className="form__label form__title-row" htmlFor="toDate">
                   <span> To Date:</span> <small > (<TimeLeft endtime={toDate} />)</small> </label>
                <input
                    className={`form__input  ${!toDate &&'form__input--incomplete'}`}
                    id="toDate"
                    name="toDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${toDate.getFullYear().toString()}-${(toDate.getMonth() + 1).toString().padStart(2, 0)}-${toDate.getDate().toString().padStart(2, 0)}T${toDate.getHours().toString().padStart(2, 0)}:${toDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setToDate(new Date(e.target.value))}
                />
                </div>
                </div>
                <div className="form-flex">
                <div className="form-input-container">


                    <label className="form__label form__checkbox-container" htmlFor="group">
                        GROUP:</label>
                    <select
                        id="group"
                        name="group"
                        className={`form__input  ${!group &&'form__input--incomplete'}`}
                        value={group}
                        onChange={(e)=>setGroup(e.target.value)}
                    >
                        <option></option>
                        {options}
                    </select>
                </div>
                <div className="form-input-container">
                  <label className="form__label" htmlFor="action-order">
                    Order:</label>
                <input
                    className={`form__input `}
                    id="action-order"
                    name="order"
                    type="number"
                    autoComplete="off"
                    value={order}
                    onChange={(e)=>setOrder(e.target.value)}
                />
                </div>
                <div className="form-input-container">
                  <label className="form__label" htmlFor="action-ratio">
                  Ratio:</label>
                <input
                    className={`form__input `}
                    id="action-ratio"
                    name="ratio"
                    type="number"
                    autoComplete="off"
                    value={ratio}
                    onChange={(e)=>setRatio(e.target.value)}
                />
                </div>

     
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-include-in-grade">
                    Inclued In Grade:
                    <input
                        className="form__checkbox"
                        id="user-include-in-grade"
                        name="user-include-in-grade"
                        type="checkbox"
                        checked={incluedInGrade}
                        onChange={(e)=>setIncluedInGrade(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-relatedFriend">
                    סימון ציון גם לחברות בברירת מחדל
                    <input
                        className="form__checkbox"
                        id="user-relatedFriend"
                        name="user-relatedFriend"
                        type="checkbox"
                        checked={defaultCheckInclueRelatedFriends}
                        onChange={(e)=>setDefaultCheckInclueRelatedFriends(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <GradeStepsMain gradeSteps={gradeSteps} setGradeSteps={setGradeSteps} />
                </div>


                <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>

            </form>
        </>
    )

    return content
}

export default NewTaskForm